module.exports = true;


//////////////////
// WEBPACK FOOTER
// /app/node_modules/core-js/library/modules/_library.js
// module id = 336
// module chunks = 0